import _ from "lodash";
import React, { useState, useRef } from "react";

import { useI18n } from "Hooks";
import classes from "./AddMembersSearch.scss";

import UsersAndCohortsPopover from "../UsersAndCohortsPopover";
import SearchInput from "MessagingV2/components/ThreadList/CreateNewChatModal/components/SearchInput";

const AddMembersSearch = props => {
  const {
    handleAddUsers,
    excludedUserIds,
    overlayContainerStyle,
    handleAddGrade,
    includePaidUsersOnly = false,
  } = props;
  const { t } = useI18n(["common"]);

  const [isOpen, setPopoverOpen] = useState(false);

  const [searchText, setSearchText] = useState("");
  const containerRef = useRef(null);

  const updateSearchText = value => {
    setSearchText(value);
    setPopoverOpen(!!_.size(value));
  };
  const handleUsersAdd = users => {
    setPopoverOpen(false);
    handleAddUsers(users);
  };

  const handleGradeAdd = param => {
    setPopoverOpen(false);
    handleAddGrade(param);
  };

  const onFocus = () => {
    if (_.size(searchText)) setPopoverOpen(true);
  };

  return (
    <div className={classes.searchContainer}>
      <SearchInput
        onFocus={onFocus}
        updateSearchText={updateSearchText}
        searchText={searchText}
        placeholder={t("common:search_for_user_class_grade_placeholder")}
      />
      <div
        className={classes.usersAndCohortsPopoverContainer}
        ref={containerRef}
      >
        <UsersAndCohortsPopover
          containerRef={containerRef}
          searchText={searchText}
          handleUsersAdd={handleUsersAdd}
          excludedUserIds={excludedUserIds}
          overlayContainerStyle={overlayContainerStyle}
          isOpen={isOpen}
          handleGradeAdd={handleGradeAdd}
          includePaidUsersOnly={includePaidUsersOnly}
          setPopoverOpen={setPopoverOpen}
        />
      </div>
    </div>
  );
};

export default AddMembersSearch;
